import { render, staticRenderFns } from "./Meus-Alunos.vue?vue&type=template&id=d8658bd0&"
import script from "./Meus-Alunos.vue?vue&type=script&lang=js&"
export * from "./Meus-Alunos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Meus-Alunos.vue"
export default component.exports